document.addEventListener('turbolinks:load', () => {

    const SgPreviewLanguageSelectForm = document.getElementById('SgPreviewLanguageSelectForm')
    const sgScreen = document.getElementById('sgScreenGuest') || document.getElementById('sgScreen')

    if (sgScreen !== null && SgPreviewLanguageSelectForm !== null) {
        SgPreviewLanguageSelectForm.addEventListener('submit', function (e) {
            if ($("input[name=languageSelect]:checked").length !== 1) {
                e.preventDefault()
                return false
            }
        })

    }
})